import React, { useContext, useState } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { MessageBar, MessageBarButton } from '@bingads-webui-react/fabric-control';

import { useStyles } from './styles';

export function IORecommendationMessageBar({
  numOfRecommendations, buttonOnClick, dismissOnClick, recommendationIds,
}) {
  const styles = useStyles();
  const i18n = useContext(I18nContext);
  const [show, setShow] = useState(numOfRecommendations > 0);
  const recommendationText = i18n.getString(
    _TL_('We\'ve noticed a trend in your insertion order frequency and spend rate, and provide {{numOfRecommendations}} recommendation(s) for you.'),
    { numOfRecommendations }
  );
  return (
    show &&
    <MessageBar
      className={classnames('io-recommendation', styles.RecommendationMessageBar)}
      actions={
        <MessageBarButton
          onClick={() => {
            buttonOnClick({ recommendationIds });
          }}
        >
          {i18n.getString(_TL_('View details'))}
        </MessageBarButton>
      }
      isMultiline={false}
      messageBarIconProps={{
        iconName: 'lightbulb',
        className: `icon-lightbulb ${styles.Icon}`,
      }}
      onDismiss={() => {
        setShow(false);
        dismissOnClick();
      }}
    >
      <span className={styles.RecommendationMessageText} title={recommendationText}>
        <b>{i18n.getString(_TL_('Recommendations: '))}</b>
        {recommendationText}
      </span>
    </MessageBar>
  );
}

IORecommendationMessageBar.defaultProps = {
  numOfRecommendations: 0,
  buttonOnClick: _.noop,
  dismissOnClick: _.noop,
};

IORecommendationMessageBar.propTypes = {
  numOfRecommendations: PropTypes.number,
  buttonOnClick: PropTypes.func,
  dismissOnClick: PropTypes.func,
};
